export enum TransformationMode {
    NONE,
    TRANSLATION,
    ROTATION,
    SCALING
}
